
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M16.81 12.45l10.74 10.74M23.19 27.55L12.45 16.81M22.37 37.03l-4.419-4.42L32.61 17.95l4.42 4.42z"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M34.57 24.82l3.93 3.93-9.75 9.75-3.93-3.93M17.63 2.98l4.419 4.42L7.39 22.057l-4.42-4.42z"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M5.43 15.18L1.5 11.25l9.75-9.75 3.93 3.93"}})])
          )
        }
      }
    